module.exports = __webpack_public_path__ + "857b8125c4a98d9f7e07d48667bd16fe.png";